var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M2.534,20.418v-9.58H0V7.388H2.534V4.441C2.534,2.126,4.03,0,7.478,0A20.936,20.936,0,0,1,9.906.134L9.825,3.355s-1.053-.01-2.2-.01c-1.243,0-1.443.573-1.443,1.524V7.388H9.924l-.163,3.449H6.18v9.58H2.534"}));
}

Facebook.defaultProps = {"viewBox":"0 0 9.924 20.418"};

module.exports = Facebook;

Facebook.default = Facebook;
